var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"scene-container"}},[_c('div',{attrs:{"id":"scene"}})])
}]

export { render, staticRenderFns }